import * as React from 'react';
// @ts-expect-error
import Select, {mergeStyles} from 'react-select';
// @ts-expect-error
import type {SelectBaseProps, MultiValueProps} from 'react-select';

import {colors} from '../colors/colors';
import {ValueComponent} from '../select-inline/value-component';
import type {TokenStyle} from '../select-inline/value-component';

import {getCustomMenuList} from './custom-menu-list';
import type {FooterButtonProps} from './select-picker-generic';
import type {ActionMeta} from './select-picker-generic-creatable';
import {selectPickerGenericStyles} from './select-picker-generic-styles';

type Props = SelectBaseProps & {
    value?: any[] | null | undefined;
    options: any[];
    isMulti: boolean;
    valueKey?: string;
    // Matches the size of SelectPickerGeneric
    isSmall?: boolean;
    labelKey?: string;
    hasError?: boolean | null | undefined;
    onClear?: () => void;
    onChange?: (newValue: any, actionMeta: ActionMeta) => void;
    tokenizedStyle?: TokenStyle;
    footerButton?: FooterButtonProps;
    menuZIndex?: number;
};

export function SelectPickerGenericMulti(props: Props) {
    const {styles, hasError, onClear, onChange, footerButton, ...restProps} = props;

    const componentStyles = {
        // @ts-expect-error
        input: (base) => ({
            ...base,
            padding: 0,
            marginBottom: props.isSmall ? 0 : 6,
        }),
        // @ts-expect-error
        control: (base, state) => {
            let controlStyles = {
                ...base,
                border: hasError ? `1px solid ${colors.rose}` : `1px solid ${colors.offWhiteDk}`,
                paddingTop: props.isSmall ? '0' : '5px',
                height: 'unset',
            };

            if (state.isDisabled || props.isDisabled) {
                controlStyles = {
                    ...controlStyles,
                    color: 'var(--grey-lt)',
                    backgroundColor: 'var(--off-white)',
                    opacity: 0.6,
                };
            }

            return controlStyles;
        },
        // @ts-expect-error
        indicatorsContainer: (base) => ({
            ...base,
            marginTop: props.isSmall ? 0 : -5,
        }),
        // @ts-expect-error
        placeholder: (base) => ({
            ...base,
            marginTop: props.isSmall ? 0 : -3,
            color: base.color,
            transition: 'color 200ms linear',
        }),
        // @ts-expect-error
        indicatorSeparator: (base, state) => ({
            ...base,
            display: onClear && state.hasValue ? undefined : 'none',
        }),
        // @ts-expect-error
        multiValueRemove: (base) => ({
            ...base,
            '&:hover': {
                backgroundColor: '#e6e6e6;',
                color: 'black',
            },
        }),
        // @ts-expect-error
        menu: (base) => {
            let menuStyles = {
                ...base,
            };

            if (props.menuZIndex) {
                menuStyles = {
                    ...menuStyles,
                    zIndex: props.menuZIndex,
                };
            }

            return menuStyles;
        },
        // @ts-expect-error
        menuPortal: (base) => ({
            ...base,
            zIndex: props.menuZIndex ?? '100001',
        }),
        ...(footerButton && {
            // @ts-expect-error
            menuList: (base) => ({
                ...base,
                paddingBottom: 42,
            }),
        }),
    } as const;

    let mergedStyles = mergeStyles(selectPickerGenericStyles, componentStyles);

    // Add in styles from props
    if (styles) {
        mergedStyles = mergeStyles(mergedStyles, styles);
    }

    // @ts-expect-error
    const handleChange = (newValue, actionMeta) => {
        if (actionMeta.action === 'clear' || newValue === null || typeof newValue === 'undefined') {
            if (onClear) {
                onClear();
            }
        } else if (onChange) {
            onChange(newValue, actionMeta);
        }
    };

    const getMultiValueComponent = (propsFromReactSelect: MultiValueProps) => {
        return (
            <div className={props.isSmall ? 'pt-4' : ''}>
                <ValueComponent
                    data={propsFromReactSelect.data}
                    labelKey={props.labelKey || 'label'}
                    valueKey={props.valueKey || 'value'}
                    tokenizedStyle={props.tokenizedStyle || 'light'}
                    onRemove={propsFromReactSelect.removeProps.onClick}
                />
            </div>
        );
    };

    return (
        <Select
            {...restProps}
            isMulti={true}
            onChange={handleChange}
            styles={mergedStyles}
            components={{
                MultiValue: getMultiValueComponent,
                MenuList: getCustomMenuList(footerButton),
            }}
        />
    );
}
